/**
 * gris para fondo de graficos #595e62 este color de fondo que quiere el diego
 */
export const plotBackground = "";

/**
 * Arreglo de colores para lineas de graficos
 */
export const chartLineColor = {
  azul: "#4472C4",
  rojo: "#C00000",
  verde: "#00B050",
  amarillo: "#FFC000",
  morado: "#7030A0",
  celeste: "#00B0F0",
  negro: "#000000",
};
